import hash from 'object-hash'

export const getHashedObject = (obj?: object) => {
  return hash(obj || {})
}
